import { Routes as CoreRoutes } from 'core/pages'
import ShippingParcelStart from './ShippingParcelStart'
import ShippingStart from './ShippingStart'

///////////////////////////////////////////////////////////////////////////////
// Custom & core overrides, change only this!
///////////////////////////////////////////////////////////////////////////////

/*
const CustomRoutes = {
  '/simple-item-list/:opCode/reading': { component: SimpleItemListReading },
  '/simple-parcel-list/:opCode': { component: SimpleParcelListStart },
}
*/

const CustomDirectRoutes = {}
const CustomRoutes = {
  '/shipping/:opCode': { component: ShippingStart },
  '/shipping/:opCode/asn/:asnId': { component: ShippingParcelStart }
}

///////////////////////////////////////////////////////////////////////////////

export const Routes = { ...CustomDirectRoutes, ...CoreRoutes, ...CustomRoutes }
// eslint-disable-next-line
export type Routes = keyof typeof Routes
